import axiosInstance from './axios';

import { generateIdempotencyKey } from '../utils/idempotency';

export const paymentService = {
  getDepositMethods: async () => {
    const url = '/client/payment/id/deposit-methods';
    const response = await axiosInstance.get(url);
    return response.data;
  },
  getWithdrawMethods: async () => {
    const url = '/client/payment/id/withdraw-methods';
    const response = await axiosInstance.get(url);
    return response.data;
  },
  createDepositAddress: async (methodId: number, networkId: number) => {
    const response = await axiosInstance.post('/client/payment/deposit', {
      depositMethodId: methodId,
      networkId: networkId,
    });
    return response.data;
  },
  createWithdrawal: async (
    data: {
      withdrawMethodId: number;
      amount: string | number;
      destinationAddress: string;
      destinationTag?: string;
      currencyCode: string;
      networkId: number;
    },
    idempotencyKey?: string,
  ) => {
    const key = idempotencyKey || generateIdempotencyKey();
    const response = await axiosInstance.post('/client/payment/withdrawal', data, {
      headers: {
        'Idempotency-Key': key,
      },
    });
    return response.data;
  },
  getCryptoQuote: async (withdrawMethodId: number, amount: string | number, networkId: number) => {
    const response = await axiosInstance.get(
      `/client/payment/crypto-quote?withdrawMethodId=${withdrawMethodId}&networkId=${networkId}&amount=${amount}`,
    );
    return response.data;
  },
  cancelWithdrawal: async (txId: string) => {
    const response = await axiosInstance.post(
      `/client/payment/withdraw-transactions/${txId}/cancel`,
    );
    return response.data;
  },
};
